import usePersonalizedThemeByCompany from "src/hooks/usePersonalizedThemeByCompany"

export default function RefreshIcon() {

  const {styledTheme} = usePersonalizedThemeByCompany()

return (
<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M1 5.27778C2.55556 2.55556 5.25279 1 8 1C11.6004 1 14.5659 3.71813 14.9564 7.21425M1 5.27778V1.77778M1 5.27778H4.11111M1.04272 8.77776C1.42961 12.2777 4.3969 15 8 15C10.7477 15 13.4444 13.4444 14.9564 11.1111M15 14.2222V11.1111H11.8889" stroke={styledTheme.colors.primary} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
)
}